import React from 'react';

// import { Container } from './styles';

function catalog() {
  return <div>Lesson Plan</div>;
}

export default catalog;